import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { concat, of, Subject } from 'rxjs';
import {
    catchError, debounceTime,
    distinctUntilChanged, filter, finalize,
    startWith,
    switchMap, takeUntil,
    tap
} from 'rxjs/operators';
import { DEFAULT_EDITOR_TOOLBAR_CONFIG, ToastService } from 'src/app/core';
import { ActiveDirectoryService } from 'src/app/core/active-directory.service';
import {
    ActivityStatus,
    AdUser,
    CandidateProfile, EmailApi,
    ImmigrationApi, ImmigrationEmailAttachments, ImmigrationEmailMessage,
    ImmigrationProfileActivity
} from 'src/app/core/api.gen';
import { AttachmentUploadService } from 'src/app/core/attachment-upload.service';
import { AuthService } from 'src/app/core/auth.service';
import { DocumentUploadService } from 'src/app/core/document-upload.service';
import { LoaderService } from 'src/app/core/loader.service';
import { OpenFilePreviewService } from 'src/app/core/open-file-preview.service';
import { nullSafe } from 'src/app/utils';
import { Logger } from 'src/app/utils/Logger';
import { isNullOrUndefined } from '../../../app/core/utils';
import { DocumentService } from '../../core/document.service';
import { ModuleTypes } from '../module-types';

@Component({
  selector: 'eos-immigration-email',
  templateUrl: './immigration-email.component.html'
})
export class ImmigrationEmailComponent implements OnInit {

  candidate_Id: number;

  @Input() public activity: ImmigrationProfileActivity;
  candidate: CandidateProfile;

  onDestroy$ = new Subject<void>();
  tosearchInput$ = new Subject<string>();
  ccsearchInput$ = new Subject<string>();
  toAdUsers: any = [];
  ccAdUsers: any = [];
  toShowLoader;
  ccShowLoader;
  tos = [];
  ccs = [];

  onSubmit: Function;

  emailpattern = /^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
  fromaddress: string;
  toaddress: string;
  date: string;
  subject: string;
  content: string;
  navLinks: any[];
  activeLinkIndex = -1;
  editorForm: UntypedFormGroup;
  results: ImmigrationEmailMessage;
  isDisabled = false;
  activitytemplateId: number;
  selectedactivitytemplate: any;

  uploadedFiles: ImmigrationEmailAttachments[] = [];
  candidateDocs = [];
  selectedCandiFiles = [];
  newAttachments: ImmigrationEmailAttachments[] = [];

   //customAttachments: string[] = [];

  toolbarConfig = { ...DEFAULT_EDITOR_TOOLBAR_CONFIG };

  // upload

  docnamePattern = "^[a-zA-Z0-9 ]*$";
  lookupType: number;
  readonly: boolean;
  country: number;

  @ViewChild('fileField', { static: true }) element: ElementRef;
  @ViewChild('fileControl', { static: true }) fileEle: ElementRef;
  @ViewChild('f', { static: true }) form: NgForm;
  immigrationCandidateActivityId?: number;
  fileDetails: ImmigrationEmailAttachments;
  selectedDocument: File;
  disableUpload = false;
  moduleType = ModuleTypes.Immigration;
  showUpload = true;

  readonly allowedMineTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.ms-excel'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];

  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;
  constructor(
    private attachmentUploadService: AttachmentUploadService,
    private documentUploadService: DocumentUploadService,
    public modal: NgbActiveModal,
    private emailAPI: EmailApi,
    private toast: ToastService,
    private loader: LoaderService,
    private ad: ActiveDirectoryService,
    public authService: AuthService,
    private openFilePreviewService: OpenFilePreviewService,
    private immigrationApi: ImmigrationApi,
    private documentService: DocumentService ) { }

  ngOnInit(): void {
    this.immigrationCandidateActivityId = this.activity.id;
    this.candidate_Id = this.activity.immigrationProfileId;
    this.results = new ImmigrationEmailMessage();
    this.fileDetails = new ImmigrationEmailAttachments();
    this.fileDetails.immigrationProfileActivityId = this.immigrationCandidateActivityId;
    this.form.valueChanges.subscribe(x =>
      this.patternValid(this.form)
    );
    this.emailAPI.getImmigrationActivityEmailMessage(this.candidate_Id, this.activity.id, this.results.activityTemplateId)
      .subscribe((resp) => {
        this.results = resp;
        this.results.activityTemplateId = resp.activityTemplateId;
        this.editorForm.patchValue({ email: this.results.content });
        this.tos = this.addAddresses(resp.toAddresses);
        this.ccs = this.addAddresses(resp.cc);
        this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.activityId, this.results.activityTemplateId);
        this.getNewlyUploadedAttachmentDetails(this.results.activityTemplateId);
        // this.results.customAttachments = this.uploadedFiles;
      });

    this.editorForm = new UntypedFormGroup({
      email: new UntypedFormControl(null)
    });
    this.toAdUsers = this.getAdUsers(true, this.tosearchInput$);
    this.ccAdUsers = this.getAdUsers(false, this.ccsearchInput$);
  }


  getNewlyUploadedAttachmentDetails(emailTemplateId: number) {
    this.emailAPI.getAttachmentsNewDetails(emailTemplateId).subscribe(resp => {
      this.newAttachments = resp;
    });
  }


  loadCandidateDocs() {
    this.immigrationApi.getAllDocumentDetails(this.candidate_Id)
      .subscribe(resp => {
        this.candidateDocs = this.documentService.updateCandidateDocs(this.uploadedFiles, true, this.documentService.changeDocumentName(resp, this.moduleType));
      });
  }

  attachCandidateFilesToMail(value) {
    this.selectedCandiFiles = value;
    if (this.selectedCandiFiles.length > 0) {
      if ((this.results.customAttachments.some((cDoc) => (cDoc.fileName === this.selectedCandiFiles[0].fileName) && (cDoc.id == this.selectedCandiFiles[0].id))
      ||(this.uploadedFiles.some((item) => (item.fileName === this.selectedCandiFiles[0].fileName) && (item.id !== this.selectedCandiFiles[0].id) && (item.fileGuiId === this.selectedCandiFiles[0].fileGuiId)))
    )
      ) {
        this.toast.error("Attachment Name should be unique");
        return;
      }
      this.immigrationApi.attachCandidateDocsToMail(this.candidateEmailAttachments())
        .subscribe(resp => {
          this.uploadedFiles.push(...resp);
          this.toast.success("File uploaded successfully!");
          this.candidateDocs = this.documentService.updateCandidateDocs(this.selectedCandiFiles, true, this.candidateDocs);
        }, () => {
          this.toast.error("Something went wrong, couldn't attach files. Please try again later")
        });
    }
  }
  
  candidateEmailAttachments() {
    let files = [];
    this.selectedCandiFiles.forEach(item => {
      const attachment = new ImmigrationEmailAttachments({
        fileName: item.fileName,
        fileGuiId: item.fileGuiId,
        immigrationProfileActivityId: this.activity.id,
        emailTemplateId: this.results.activityTemplateId
      })
      files.push(attachment)
    });
    return files;
  }

  adUser() {
    return new AdUser({
      displayName: `${this.candidate.firstName} ${this.candidate.lastName}`,
      userPrincipalName: this.candidate.emailID,
    });
  }

  patternValid(f: NgForm) {
    const ccForm = f.form.get("cc");
    const addressForm = f.form.get("toAddresses");

    if (!isNullOrUndefined(addressForm)) {
      addressForm.value.forEach(item => {
        if (!item.match(this.emailpattern) && !isNullOrUndefined(addressForm)) {
          addressForm.setErrors({ incorrect: true });
        }
      });
    }

    if (!isNullOrUndefined(ccForm)) {
      if (ccForm.value.length === 0) {
        ccForm.setErrors(null);
        return;
      }
      ccForm.value.forEach(item => {
        const valid = item.match(this.emailpattern);
        if (!item.match(this.emailpattern) && !isNullOrUndefined(ccForm)) {
          ccForm.setErrors({ incorrect: true });
        }
      });
    }
  }

  addAddresses(email: string) {
    const emailArray = [];
    if (email && email.length > 0) {
      email.split(';').forEach(item => {
        // if (item.match(this.emailpattern)) {
        if (item != "") {
          emailArray.push(item);
        }
       
        // }
      });
    }

    return emailArray;
  }

  getAdUsers(setToLoader: boolean, subject) {
    let obs = concat(
      of([]),
      subject.pipe(
        takeUntil(this.onDestroy$),
        startWith(''),
        filter((v: string) => v !== null && v.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.setAdloader(setToLoader);
        }),
        switchMap((term: string) => this.ad.getAdUsers(term).pipe(
          catchError(() => of([])),
          tap((users) => {
            this.toShowLoader = false;
            this.ccShowLoader = false;
            if (nullSafe<boolean>(() => this.candidate.firstName.toLowerCase().startsWith(term.toLowerCase()), false)
              || nullSafe<boolean>(() => this.candidate.emailID.toLowerCase().startsWith(term.toLowerCase()), false)) {
              users.push(this.adUser());
            }
          })
        ))
      ));
    return obs;
  }

  setAdloader(isToLoader) {
    if (isToLoader) {
      this.toShowLoader = true;
      this.ccShowLoader = false;
    } else {
      this.toShowLoader = false;
      this.ccShowLoader = true;
    }
  }


  getUploadedAttachmentDetails(profileId: number, activityId: number, emailTemplateId: number) {
    this.immigrationApi.getAttachmentsDetails(profileId, activityId, emailTemplateId).subscribe(resp => {
      this.uploadedFiles = resp;
     this.loadCandidateDocs();
      // this.results.customAttachments = this.uploadedFiles;
      // this.results.customAttachments = resp;
      // console.log(this.uploadedFiles);
    });
  }

  delete(fileDetails) {
    this.immigrationApi.deleteAttachment(fileDetails).subscribe((resp) => {
      this.toast.success("Attachment deleted!");
      this.selectedCandiFiles = [];
      this.selectedCandiFiles.push(fileDetails);
      this.candidateDocs = this.documentService.updateCandidateDocs(this.uploadedFiles, false, this.candidateDocs);
      this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.activityId, this.results.activityTemplateId);
    });
  }

  downloadAttachment(details) {
    this.attachmentUploadService.downloadAttachment(details);
  }



  GetDocuments($event) {
    this.uploadedFiles = $event;
    this.results.customAttachments = this.uploadedFiles;
    this.results.customAttachments = $event;
  }

  sendMail(f: NgForm) {

    if (f.invalid) {
      return;
    }
    this.results.toAddresses = this.tos.join(';');
    this.results.cc = this.ccs.join(';');
    this.results.immigrationProfileActivityId = this.activity.id;
    this.results.customAttachments = [...this.uploadedFiles, ...this.newAttachments,...this.results.customAttachments];
   
    this.isDisabled = true;
    this.loader.show();
    this.emailAPI.sendImmigrationMail(this.candidate_Id, this.results).pipe(finalize(() => {
      this.isDisabled = false;
    }))
      .subscribe((resp) => {
        this.updateActivity().pipe(finalize(() => {
          this.loader.clear();
        })).subscribe((res) => {
          this.toast.success("Activity completed");
          this.onSubmit(res.completedDate, res);
          this.modal.close();
        });
      }, (err) => {
        this.toast.error('Error occured while sending email.');
        this.loader.clear();
        Logger.error(err);
        this.modal.close();
      });
  }

  TemplateLoad(e) {
    this.uploadedFiles = null;
    this.activitytemplateId = e.target.value;
    this.emailAPI.getImmigrationActivityEmailMessage(this.candidate_Id, this.activity.id, this.results.activityTemplateId)
      .subscribe((resp) => {
        this.results = resp;
        this.results.activityTemplateId = resp.activityTemplateId;
        this.tos = this.addAddresses(resp.toAddresses);
        this.ccs = this.addAddresses(resp.cc);
        this.editorForm.patchValue({ email: this.results.content });
        this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.activityId, this.results.activityTemplateId);

      });

  }

  
  removeAttachment(id) {
    if (this.newAttachments.includes(id) ){
    this.newAttachments.splice(this.newAttachments.indexOf(id), 1);
  }
  else if(this.results.customAttachments.filter(x=> x.id== id)){
    this.results.customAttachments.splice(this.results.customAttachments.findIndex(x=> x.id ==id), 1);
  }
    else {
      this.results.attachments.splice(id, 1);
    }
  }

 

  updateActivity() {
    return this.immigrationApi.updateImmigrationActivity(this.candidate_Id, this.activity.id, ActivityStatus.Done);
  }

  // Upload Controls

  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }

    return false;
  }

  browseFile() {
    // console.log(this.fileEle);
    this.fileEle.nativeElement.click();
  }

  get fileBrowserAllowedTypes() {
    return this.allowedMineTypes.join(',');
  }

  fileSelected(files: FileList) {
    // console.log(files);
    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {

      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB
       and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);

      this.fileEle.nativeElement.value = null;
      return;
    }
    if (this.allowedMineTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }

    this.fileDetails.fileName = this.selectedDocument.name;
  }

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }


  uploadDoc(f: NgForm) {

    // console.log(this.uploadedFiles);
    // this.getUploadedAttachmentDetails(this.candidateActivityId);

    if (f.invalid) {
      return;
    }

    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()}
       KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }
    // if (this.allFiles.some((item) => (item.fileName === this.fileDetails.fileName) && (item.id !== this.fileDetails.id))) {
    if (this.uploadedFiles.some((item) => (item.fileName === this.selectedDocument.name) && (item.id !== this.fileDetails.id))) {
      this.toast.error("Attachment Name should be unique");
      return;
    }

    this.fileDetails.id = -1;
    this.fileDetails.immigrationProfileActivityId = this.immigrationCandidateActivityId;
    this.fileDetails.emailTemplateId = this.results.activityTemplateId;
    this.fileDetails.createdById = this.authService.ActiveUser.employeeId;
    this.fileDetails.modifiedById = this.authService.ActiveUser.employeeId;
    this.fileDetails.candidateId = this.candidate_Id;
    this.fileDetails.activityId = this.activity.activityId;

    this.upload(f);

    // this.getUploadedAttachmentDetails(this.candidateActivityId);
  }

  upload(f: NgForm) {
    f.form.disable();
    this.disableUpload = true;
    this.isDisabled = true;
    this.attachmentUploadService.postImmigrationFile(this.fileDetails, this.selectedDocument).pipe(finalize(() => {
      this.selectedDocument = null;
      this.fileEle.nativeElement.value = null;
      f.form.enable();
      this.disableUpload = false;
      this.isDisabled = false;
      // f.reset({});
    }))
      .subscribe(resp => {
        // this.updateAllFiles(resp.data);
        this.element.nativeElement.value = "";
        if (this.selectedDocument) {
          this.toast.success("File uploaded successfully!");
        } else {
          this.toast.success("Document details updated successfully!");
        }
        this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.activityId, this.results.activityTemplateId);
      }, error => {
        this.toast.error("Something went wrong!");
      });
    // this.GetDocumentEvent.emit(this.uploadedFiles);
  }

  downloadFile(fileName: string) {
    this.documentUploadService.downloadDocumentFile(fileName);
  }

  previewFile(fileName: string) {
    this.openFilePreviewService.previewAttachmentFile(fileName);
  }

  saveMailAsDraft(f: NgForm) {

    f.form.disable();
    this.results.immigrationProfileId = this.candidate_Id;
    this.results.immigrationProfileActivityId = this.activity.id;
    this.results.toAddresses = this.tos.join(";");
    this.results.cc = this.ccs.join(";");

    this.loader.show();
    this.emailAPI.immigrationSaveAsDraft(this.results).pipe(finalize(() => {
      this.loader.clear();
      f.form.enable();
    })).subscribe(resp => {
      this.results.emailHistoryId = resp.data;
      this.toast.success("Mail saved as draft!");
    });
  }


}
